import React, { useContext } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const AddOffCanvance = (props) => {
    const { postData } = useContext(Context);
    const [showModal, setShowModal] = useState({
        code: 0,
        message: "",
    });

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        formState: { errors },
        clearErrors,
    } = useForm();
    const imageFile = watch("image");

    const onSubmit = async (data) => {
        try {
            const finalData = new FormData();
            finalData.append("name", data?.name);
            finalData.append("subname", data?.subname);
            finalData.append("description", data?.description);
            finalData.append("rating", data?.rating);
            finalData.append("image", data.image[0]);
            const response = await postData(`/admin/masters/testimonial`, finalData);

            if (response?.success) {
                await setShowModal({ code: response.code, message: response?.message });
            } else {
                await setShowModal({ code: response?.code, message: response?.message });
            }
            setTimeout(() => {
                setShowModal(0);
                props.handleClose();
            }, 1000);
        } catch (error) {
            console.log(error);
        }
    };

    const [imagePreview, setImagePreview] = useState(null); // State to store image preview

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result); // Set image preview
            };
            reader.readAsDataURL(file);
            clearErrors("image")
        }
    };

    return (
        <>
            <Modal
                {...props}
                onHide={props.handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Testimonial
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
                        <Row className="">


                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Name</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Name"
                                                className={classNames("", {
                                                    "is-invalid": errors?.name,
                                                })}
                                                {...register("name", {
                                                    required: "Name is required",
                                                    validate: (value) =>
                                                        value.length <= 200 ||
                                                        "Data must be 200 characters or less",
                                                })}
                                            />
                                        </InputGroup>
                                        {errors.name && (
                                            <span className="text-danger">{errors.name.message}</span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Sub Name</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                name="subname"
                                                placeholder="Sub Name"
                                                className={classNames("", {
                                                    "is-invalid": errors?.subname,
                                                })}
                                                {...register("subname", {
                                                    required: "Sub Name is required",
                                                    validate: (value) =>
                                                        value.length <= 200 ||
                                                        "Data must be 200 characters or less",
                                                })}
                                            />
                                        </InputGroup>
                                        {errors.subname && (
                                            <span className="text-danger">{errors.subname.message}</span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Description</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                name="description"
                                                placeholder="Sub Name"
                                                className={classNames("", {
                                                    "is-invalid": errors?.description,
                                                })}
                                                {...register("description", {
                                                    required: "Description is required",

                                                })}
                                            />
                                        </InputGroup>
                                        {errors.description && (
                                            <span className="text-danger">{errors.description.message}</span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Rating</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <Form.Control
                                                type="number"
                                                name="rating"
                                                min={1}
                                                max={5}
                                                placeholder="Rating"
                                                className={classNames("", {
                                                    "is-invalid": errors?.rating,
                                                })}
                                                {...register("rating", {
                                                    required: "rating is required",

                                                })}
                                            />
                                        </InputGroup>
                                        {errors.rating && (
                                            <span className="text-danger">{errors.rating.message}</span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Image</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <Form.Control
                                                type="file"
                                                name="image"
                                                placeholder="Image"
                                                className={classNames("", {
                                                    "is-invalid": errors?.image,
                                                })}
                                                {...register("image", {
                                                    required: "Image is required",
                                                })}
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                        </InputGroup>
                                        {errors.image && (
                                            <span className="text-danger">
                                                {errors.image.message}
                                            </span>
                                        )}
                                    </Form.Group>
                                    {imagePreview && (
                                        <div className="mt-2">
                                            <img
                                                src={imagePreview}
                                                alt="Category Preview"
                                                style={{ maxWidth: "100px" }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </Col>

                            <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                    <Link>
                                        <CancelButton
                                            name={"cancel"}
                                            handleClose={props.handleClose}
                                        />
                                    </Link>

                                    <SaveButton
                                        name={"save"}
                                        handleSubmit={handleSubmit(onSubmit)}
                                    />
                                </div>
                            </Row>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>

            <ModalSave
                message={showModal.message}
                showErrorModal={showModal.code ? true : false}
            />
        </>
    );
};

export default AddOffCanvance;
